export class RestoreAzureVmNativeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "recoveryPointId",
            "baseName": "recoveryPointId",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultName",
            "baseName": "vaultName",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultResourceGroup",
            "baseName": "vaultResourceGroup",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreType",
            "baseName": "restoreType",
            "type": "RestoreAzureVmNativeRequestRestoreTypeEnum",
            "format": ""
        },
        {
            "name": "target",
            "baseName": "target",
            "type": "AzureVmNativeRestoreTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAzureVmNativeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
export var RestoreAzureVmNativeRequestRestoreTypeEnum;
(function (RestoreAzureVmNativeRequestRestoreTypeEnum) {
    RestoreAzureVmNativeRequestRestoreTypeEnum["RestoreDisks"] = "RESTORE_DISKS";
    RestoreAzureVmNativeRequestRestoreTypeEnum["CreateNewVm"] = "CREATE_NEW_VM";
})(RestoreAzureVmNativeRequestRestoreTypeEnum || (RestoreAzureVmNativeRequestRestoreTypeEnum = {}));
